import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M20 11.25v-2.5l-2.763-.688c-.187-.689-.443-1.291-.769-1.848l1.482-2.465-1.762-1.7-2.438 1.462c-.518-.306-1.116-.562-1.747-.737L11.25-.001h-2.5l-.688 2.762c-.689.187-1.291.443-1.848.769L3.749 2.048l-1.7 1.762 1.462 2.438c-.306.518-.562 1.116-.737 1.747l-2.775.753v2.5l2.762.688c.187.689.443 1.291.769 1.848l-1.482 2.465 1.762 1.762 2.5-1.462c.518.306 1.116.562 1.747.737l.69 2.712h2.5l.688-2.763c.684-.188 1.282-.444 1.835-.769l2.465 1.482 1.763-1.762-1.463-2.5c.306-.518.562-1.116.738-1.747zM13.75 10c0 2.071-1.679 3.75-3.75 3.75S6.25 12.071 6.25 10c0-2.071 1.679-3.75 3.75-3.75s3.75 1.679 3.75 3.75z',
  ],
  height: 20,
  width: 20,
});
